import { gql } from 'graphql-request';

export const CACHE_INVOICE_UPDATE_VIEW_SETTINGS_QUERY = gql`
  mutation CacheInvoiceUpdateViewSettings($uuid: ID!, $viewSettings: Json!) {
    invoiceUpdateViewSettings(
      input: { uuid: $uuid, viewSettings: $viewSettings }
    ) {
      status
    }
  }
`;
